import { PDFGeneratorConfigInterface } from "./interfaces";

export const PAGE_MARGIN: number = 5;
export const PDF_GENERATOR_CONFIG: PDFGeneratorConfigInterface = {
  model: {},
  options: {
    excludeBuiltinStyles: false,
    landscape: false,
    margins: {
      bottom: PAGE_MARGIN,
      left: PAGE_MARGIN,
      right: PAGE_MARGIN,
      top: PAGE_MARGIN
    },
    pageFormat: "A4",
    pageSize: {
      width: 210,
      height: 297
    }
  },
  templateEngine: "golang",
  htmlTemplate: ""
};
export const FORM_RESET_PADDINGS: string = "<style>.pdf{padding:0px;}</style>";
